import { render, staticRenderFns } from "./customOrder.vue?vue&type=template&id=116bdbe3&"
import script from "./customOrder.vue?vue&type=script&lang=js&"
export * from "./customOrder.vue?vue&type=script&lang=js&"
import style0 from "./customOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports